import { db } from './firebase';
import { collection, getDocs, query, orderBy, doc, getDoc } from "firebase/firestore";

// Get all blog posts
export const getAllBlogs = async () => {
    try {
        const blogsRef = collection(db, "blogs");
        const q = query(blogsRef, orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(q);
        
        const blogs = [];
        querySnapshot.forEach((doc) => {
            blogs.push({ id: doc.id, ...doc.data() });
        });
        
        return blogs;
    } catch (error) {
        console.error("Error loading blogs:", error);
        return [];
    }
};

// Get blog by ID
export const getBlogById = async (blogId) => {
    try {
        const blogDoc = await getDoc(doc(db, "blogs", blogId));
        if (blogDoc.exists()) {
            return { id: blogDoc.id, ...blogDoc.data() };
        }
        return null;
    } catch (error) {
        console.error("Error loading blog:", error);
        return null;
    }
};